import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  fetchAttachments as fetchAttachmentsAction,
  fetchProduct as fetchProductAction,
  fetchProductMindItems as fetchProductMindItemsAction
} from '../../actions/product.actions';
import useAction from '../../utils/useAction';
import useRouter from '../../utils/useRouter';
import { routes } from '../../constants';
import { selectUser } from '../../reducers/user.selectors';
import AttachmentsContent from '../../components/AttachmentsContent';

const ProductAttachmentsPage: React.FC = () => {
  const { router, match: { params: { productId } } } = useRouter();
  const fetchProduct = useAction(fetchProductAction);
  const fetchProductMindItems = useAction(fetchProductMindItemsAction);
  const fetchAttachments = useAction(fetchAttachmentsAction);
  const user = useSelector(selectUser);

  useEffect(() => {
    fetchProduct(productId);
    fetchProductMindItems(productId);
    fetchAttachments(productId);
  }, [productId]);

  useEffect(() => {
    if (user && !user.hasDocumentLevelAccess) {
      router.replace(`/${routes.productPage.root}/${productId}`);
    }
  }, [productId, router, user]);

  if (user && !user.hasDocumentLevelAccess) {
    return <></>;
  }

  return <AttachmentsContent />;
};

export default ProductAttachmentsPage;
